import { render, staticRenderFns } from "./DowntimeCategory.vue?vue&type=template&id=917f201e&"
import script from "./DowntimeCategory.vue?vue&type=script&lang=js&"
export * from "./DowntimeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports